import useProjectEntriesCall, { toTimestampLike } from './useProjectEntriesCall'

/**
 * @typedef {object} ResearchEntry
 * @property {string} docid - Document-id van het antwoord
 * @property {{toDate: () => Date} | null} Timestamp - Zelfde vorm als een Firestore-Timestamp
 * @property {string} FormID - Id van de ingevulde vragenlijst ('' bij oude antwoorden)
 * @property {string} SessionID - Terugval voor oude antwoorden zonder FormID
 */

/** @returns {ResearchEntry} */
const toResearchDoc = (/** @type {{id: string, t: number|null, f?: string, s?: string}} */ entry) => ({
    docid: entry.id,
    Timestamp: toTimestampLike(entry.t),
    FormID: entry.f || '',
    SessionID: entry.s || '',
})

/**
 * De onderzoeksantwoorden van één project, via de Cloud Function
 * `getProjectResearchEntries`. QuestionnairesResponses is team-only, dus een
 * koepel (of de beheertenant) leest ze niet zelf. Alleen id, tijdstip en de
 * sleutels waarmee `countSubmissions` invullingen ontdubbelt — geen antwoorden.
 * AI-CONTEXT: See docs/security-kaart-2026-10-22.md
 *
 * @param {string} compagnyId - Het project; '' = nog onbekend
 * @returns {{docs: Array<ResearchEntry> | '', error: {code?: string, message?: string} | null, loading: boolean}}
 */
const useProjectResearchEntries = (compagnyId) => useProjectEntriesCall(
    'getProjectResearchEntries', compagnyId, toResearchDoc, 'useProjectResearchEntries'
)

export default useProjectResearchEntries
